var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { styled, css } from '@creditas-ui/system';
import { ifProp, selectTheme } from '@creditas-ui/utilities';
var InlineLinkWrapper = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), ifProp({
  disabled: true
}, css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])))));
var InlinelinkElement = styled('a')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: inherit;\n  font-size: inherit;\n  color: ", ";\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  ", "\n"])), props => props.color || selectTheme('inlineLink.base.color'), selectTheme('inlineLink.base.hover.opacity'), ifProp({
  disabled: true
}, _ref => {
  var {
    theme: {
      inlineLink
    }
  } = _ref;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      pointer-events: none;\n      color: ", ";\n    "])), inlineLink('base.disabledColor'));
}));
export { InlinelinkElement, InlineLinkWrapper };
//# sourceMappingURL=Inlinelink.style.js.map